/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit CreateAction/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonText from 'DesignSystem/TysiaButton/TysiaButtonText/index'



/** @type {import('Simple/types.js').View} */
export default function CreateAction({
  children,
  viewPath = "/App/Account/Content/Tasks/New/NewTaskOverlay/Content/Footer/CreateAction"
  
}) {
let tabSelectedNewTaskOverlayFormBoardIdValueData = fromData.useDataValue({ viewPath,
context: 'tab',
path: 'selected.new_task_overlay.form.board_id',
})
let tabSelectedNewTaskOverlayFormStageIdValueData = fromData.useDataValue({ viewPath,
context: 'tab',
path: 'selected.new_task_overlay.form.stage_id',
})
let tabSelectedNewTaskOverlayFormTitleValueData = fromData.useDataValue({ viewPath,
context: 'tab',
path: 'selected.new_task_overlay.form.title',
})
let tabSelectedNewTaskOverlayFormPriorityValueData = fromData.useDataValue({ viewPath,
context: 'tab',
path: 'selected.new_task_overlay.form.priority',
})
let tabSelectedNewTaskOverlayFormActionValueData = fromData.useDataValue({ viewPath,
context: 'tab',
path: 'selected.new_task_overlay.form.action',
})
let aggregateData = fromHelpers.isDisabled(tabSelectedNewTaskOverlayFormBoardIdValueData, tabSelectedNewTaskOverlayFormStageIdValueData, tabSelectedNewTaskOverlayFormTitleValueData, tabSelectedNewTaskOverlayFormPriorityValueData, tabSelectedNewTaskOverlayFormActionValueData)
let onClick = fromHelpers.useOnClick({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 type="primary"
 onClick={onClick}
 data="tab.selected.new_task_overlay.form.board_id"
 data="tab.selected.new_task_overlay.form.stage_id"
 data="tab.selected.new_task_overlay.form.title"
 data="tab.selected.new_task_overlay.form.priority"
 data="tab.selected.new_task_overlay.form.action"
 aggregate="helpers.js isDisabled"
 disabled={aggregateData}
>
{childProps => (
<TysiaButtonText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonText`}
 text="Create new task"
/>
)}
</TysiaButton>
{children}
</React.Fragment>)
}